import React from "react";
import { Check } from "lucide-react";

export const CheckMarkCircle = ({
  complete,
  onClick,
  disabled,
}: {
  complete: boolean;
  onClick: () => void;
  disabled: boolean;
}) => {
  if (complete) {
    return (
      <div className="flex size-[25px] items-center justify-center rounded-full bg-button-bright">
        <Check className="text-white" size={20} />
      </div>
    );
  }
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      disabled={disabled}
      className="size-[25px] rounded-full border border-2 border-icon-light disabled:pointer-events-none"
    ></button>
  );
};
